import axios from "axios";
import baseURL from "../config/api";

export const post_Member = (data: any, token: string) => {
    return axios({
        url: `${baseURL}member`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_Member = (data: any, token: string) => {
    return axios({
        url: `${baseURL}member`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_Member = (primaryKey: string, token: string) => {
    return axios({
        url: `${baseURL}member`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey }
    }).then(response => response.data);
}

export const fetchAllMembersForExport = async (
    groupId: string,
    userId: number,
    exportedBy: string,
    token: string
) => {
    const response = await axios({
        url: `${baseURL}member/GetMemberReportByGroupId/${groupId}`,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: {
            userId,
            exportedBy,
        },
        withCredentials: true,
    });

    return response.data;
};

export const getMemberByGroupId = (groupId: string, token: string) => {
    return getFetch(`member/GetMembersByGroup/${groupId}`, token)
}

export const getMembers = (token: string) => {
    return getFetch(`member`, token)
}

export const getMember = (primaryKey: string, token: string) => {
    return getFetch(`member/${primaryKey}`, token)
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}